import { useQuery } from '@tanstack/react-query';
import { UserConsentsApi } from '../../../apis/UserConsentsApi/UserConsentsApi.ts';
import { IUserPreferences } from '../UserConsent.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { AppMedError } from '../../../error/AppMedError.ts';

export function useGetUserPreferences(enabled: boolean = true) {
    return useQuery<IUserPreferences, AppMedError>({
        queryKey: [QueryKeys.userPreferences],
        queryFn: async () => {
            return await UserConsentsApi.getPreferences();
        },
        enabled,
        staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
        gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
        retry: 1, // Only retry once on failure
    });
}
